import { BoxSingleMatch, BoxGenericPosterAvatar, BoxInfoMatchText, BoxNameWrestlerOrTypeMatch } from './StyledComponentsMatchCard';
import RenderNameTypeMatchCard from './RenderNameTypeMatchCard';
import RenderNamePpv from './RenderNamePpv';
import RenderBeltMatchCard from './RenderBeltMatchCard';
import { useNavigate } from 'react-router-dom';

// Container Card Match Generic
function RenderGenericMatchCard(match, keyMatch, wrestlerId) {
    //Navigazione al ppv
    const navigate = useNavigate();
    const navigateToPpv = (ppv) => {
        const ppvId = ppv.id;
        const ppvName = ppv.ppv_description.name;
        navigate(`/ppv/specific/i_${ppvId}_d_${ppvName}`);
    }

    const me = match.wrestlers?.find(w => w.id === wrestlerId);
    const winState = match.is_no_contest ? 'nc' : me?.is_winner ? 'win' : 'loss';

    return (
        <BoxSingleMatch key={keyMatch} winState={winState} className='box-single-match' onClick={() => navigateToPpv(match.ppv)}>
            <BoxGenericPosterAvatar className='box-poster-ppv'>
                <img 
                    src={process.env.REACT_APP_STORAGE_URL + match.ppv.img_path} 
                    alt={match.ppv.img_path + "_alt"}
                    className='poster-ppv'
                />
            </BoxGenericPosterAvatar>

            <BoxInfoMatchText className='box-info-match-text'>
                <BoxNameWrestlerOrTypeMatch className='box-name-type-match'>
                    <h2 className='type-match'>{match.type_match.name}</h2>
                </BoxNameWrestlerOrTypeMatch>

                {/* Nome Type Match  */}
                {RenderNameTypeMatchCard(match)}

                {/* Belt se non null */}
                {match.belt && (
                    RenderBeltMatchCard(match)
                )}

                {/* Nome PPV  */}
                {RenderNamePpv(match, keyMatch)}
            </BoxInfoMatchText>

        </BoxSingleMatch>
    )
}

export default RenderGenericMatchCard;